import { Range } from "immutable";

import { registerAPI } from "./api";
import { handleError, apiRequest } from "../lib/utils/request";
import { ValidationError } from "../../common/lib/validation";

export const REGISTER_NOTIFICATION = "REGISTER_NOTIFICATION";
export const REGISTER_NOTIFICATION_SUCCESS = "REGISTER_NOTIFICATION_SUCCESS";
export const REGISTER_NOTIFICATION_ERROR = "REGISTER_NOTIFICATION_ERROR";
export const REGISTER_NOTIFICATION_FINALLY = "REGISTER_NOTIFICATION_FINALLY";

export const register = data => async (dispatch, getState, utils) => {
  const action = REGISTER_NOTIFICATION;

  try {
    return await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      null,
      registerAPI,
      data,
      {
        headers: {
          "Content-Type": "application/json"
        }
      },
      body => {
        return new ValidationError("all", "");
      }
    );
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};



/** WEBPACK FOOTER **
 ** ./src/common/notification/actions.js
 **/